import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { API_ROUTES } from 'src/app/core/http/api-routes';
import { HttpService } from 'src/app/core/http/http.service';

interface UnattendedSection {
  class_section: string;
  section_id: number;
}

interface AbsentCount {
  section_name: string;
  class_name: string;
  absent_students_count: number;
}

interface AttendanceDashResponse {
  classSections?: UnattendedSection[];
  absentCounts?: AbsentCount[];
  shiftTwo?: UnattendedSection[];
}

@Component({
  selector: 'app-dash-absents-module',
  templateUrl: './dash-absents-module.component.html',
  styleUrls: ['./dash-absents-module.component.css']
})
export class DashAbsentsModuleComponent implements OnInit {
  loading = true;
  stdSection: UnattendedSection[] = [];
  absentCounts: AbsentCount[] = [];
  shiftTwo: UnattendedSection[] = [];

  constructor(
    private httpApi: HttpService,
    public dialogRef: MatDialogRef<DashAbsentsModuleComponent>,
  ) { }

  get shiftOneCount(): number {
    return this.stdSection?.length || 0;
  }

  get shiftTwoCount(): number {
    return this.shiftTwo?.length || 0;
  }

  get absentClassCount(): number {
    return this.absentCounts?.length || 0;
  }

  get totalAbsentStudents(): number {
    return (this.absentCounts || []).reduce(
      (sum, row) => sum + (Number(row.absent_students_count) || 0),
      0
    );
  }

  async ngOnInit() {
    try {
      const response = await this.httpApi
        .listAll(API_ROUTES.DASH_TOTAL_ATTENDENCEE)
        .toPromise() as AttendanceDashResponse;

      this.stdSection = response?.classSections || [];
      this.absentCounts = response?.absentCounts || [];
      this.shiftTwo = response?.shiftTwo || [];
    } finally {
      this.loading = false;
    }
  }
}
